import { DataType } from '@easydata/core';
import { i18n } from '@easydata/core';
import { FormatParser } from "./format_parser";
import { LinkType } from '../types/link_type';
export var equtils;
(function (equtils) {
    /**
     * Adds two paths and returns the result
     * Correctly processes leading and trailing slashes
     * @param path1
     * @param path2
     */
    function combinePath(path1, path2) {
        var result = path1;
        if (result != null && result.length > 0) {
            if (result.charAt(result.length - 1) != '/')
                result += "/";
            result += path2;
        }
        else {
            result = path2;
        }
        return result;
    }
    equtils.combinePath = combinePath;
    /**
     * Converts a string to a `LinkType` value
     * @param str
     */
    function strToLinkType(str) {
        if (str == "All") {
            return LinkType.All;
        }
        else if (str == "NotAll") {
            return LinkType.NotAll;
        }
        else if (str == "Any") {
            return LinkType.Any;
        }
        else {
            return LinkType.None;
        }
    }
    equtils.strToLinkType = strToLinkType;
    /**
     * Converts a `LinkType` value to a string
     * @param type
     */
    function linkTypeToStr(type) {
        if (type === LinkType.All) {
            return "All";
        }
        else if (type === LinkType.NotAll) {
            return "NotAll";
        }
        else if (type == LinkType.Any) {
            return "Any";
        }
        else {
            return "None";
        }
    }
    equtils.linkTypeToStr = linkTypeToStr;
    /**
     * Parses the operator's format string and returns a list of tokens
     * @param operator
     */
    function parseOperatorFormat(operator) {
        var format = i18n.getText('Operators', operator.id, 'format');
        if (!format) {
            format = i18n.getText('Operators', operator.id, 'displayFormat');
        }
        if (!format) {
            format = operator.displayFormat;
        }
        var parser = new FormatParser(format);
        return parser.parse();
    }
    equtils.parseOperatorFormat = parseOperatorFormat;
    //----------- value converstion utils --------------
    /**
     * Converts a value from one DataType to another
     * @param value
     * @param fromDataType - the original data type
     * @param toDataType - the data type we want to get
     */
    function convertValue(value, fromDataType, toDataType) {
        switch (toDataType) {
            case DataType.String:
                return value;
            case (DataType.Autoinc, DataType.Byte, DataType.Int32, DataType.Int64, DataType.Word):
                var resInt = parseInt(value);
                return isNaN(resInt) ? '' : resInt.toString();
            case (DataType.Currency, DataType.Float):
                var resFloat = parseFloat(value);
                return isNaN(resFloat) ? '' : resFloat.toString();
            default:
                return '';
        }
    }
    equtils.convertValue = convertValue;
})(equtils || (equtils = {}));
//# sourceMappingURL=utils.js.map